/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S2_HeadingInputs */

const tr_iletisim_s2_heading = /** @type {(inputs: Iletisim_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destek ve Genel İletişim`)
};

const en_iletisim_s2_heading = /** @type {(inputs: Iletisim_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support and general contact`)
};

const de_iletisim_s2_heading = /** @type {(inputs: Iletisim_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support und allgemeiner Kontakt`)
};

const ru_iletisim_s2_heading = /** @type {(inputs: Iletisim_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка и общие вопросы`)
};

/**
* | output |
* | --- |
* | "Support and general contact" |
*
* @param {Iletisim_S2_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s2_heading = /** @type {((inputs?: Iletisim_S2_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S2_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s2_heading(inputs)
	if (locale === "de") return de_iletisim_s2_heading(inputs)
	if (locale === "ru") return ru_iletisim_s2_heading(inputs)
	return tr_iletisim_s2_heading(inputs)
});